export default __webpack_public_path__ + "static/media/nikeCover.ee214dff.jpg";